import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDownloadVideo, useVideoList } from '../queries';

const HomePage: React.FC = () => {
  const [url, setUrl] = useState('');
  const navigate = useNavigate();
  const downloadVideo = useDownloadVideo();
  const { data: videoList, isLoading: isLoadingVideos } = useVideoList();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!url.trim()) return;
    
    try {
      const result = await downloadVideo.mutateAsync({ url });
      // Navigate to video playback page
      navigate(`/videos/${result.video_id}`);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const extractVideoId = (url: string): string | null => {
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) {
        return match[1];
      }
    }
    return null;
  };

  const isValidUrl = (url: string): boolean => {
    return extractVideoId(url) !== null;
  };

  return (
    <div className="container">
      <h1 style={{ textAlign: 'center', marginBottom: '40px' }}>
        YouTube Background Video Player
      </h1>
      
      <div className="input-form">
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="Enter YouTube URL..."
              disabled={downloadVideo.isPending}
            />
            <button 
              type="submit" 
              disabled={downloadVideo.isPending || !isValidUrl(url)}
            >
              {downloadVideo.isPending ? 'Downloading...' : 'Download Video'}
            </button>
          </div>
        </form>
        
        {downloadVideo.isError && (
          <div className="error">
            Error: {downloadVideo.error?.message}
          </div>
        )}
      </div>

      {isLoadingVideos ? (
        <div className="loading-spinner">
          <div className="spinner"></div>
          Loading videos...
        </div>
      ) : videoList && videoList.videos.length > 0 ? (
        <div className="video-list">
          <h2>Recent Downloads</h2>
          {videoList.videos.map((video) => (
            <div key={video.video_id} className="video-item">
              <h3>Video ID: {video.video_id}</h3>
              <p>Filename: {video.filename}</p>
              <p>Size: {(video.size / (1024 * 1024)).toFixed(2)} MB</p>
              <a href={`/videos/${video.video_id}`}>
                Watch Video
              </a>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginTop: '40px', color: '#666' }}>
          No videos downloaded yet. Enter a YouTube URL above to get started!
        </div>
      )}
    </div>
  );
};

export default HomePage;
